import { EMPTY_STATE_IMAGES } from '@shared/constants';
import { AddIcon } from '@sketchnote/icons';
import { LoaderXs } from '@sketchnote/shared-components';
import classNames from 'classnames';
import { useState } from 'react';
import { DropEvent, FileRejection, useDropzone } from 'react-dropzone';
interface FileUploadProps {
  acceptTypes?: string | string[];
  onDrop?: <T extends File>(
    acceptedFiles: T[],
    fileRejections: FileRejection[],
    event: DropEvent
  ) => void;
  className?: string;
  translations: {
    attachments_label: string;
    attachments_drop_label: string;
  };
  maxFileSize?: number;
  multiple?: boolean;
  maxFiles?: number;
  pdfUrl: string;
  isLoading: boolean;
}

export const PdfUpload = ({
  onDrop,
  acceptTypes,
  className,
  translations,
  pdfUrl,
  isLoading,
}: FileUploadProps) => {
  const { getRootProps, getInputProps, isDragActive, isFileDialogActive } = useDropzone({
    onDrop,
    accept: acceptTypes,
  });

  const classes = classNames({
    'flex-col w-3/5 m-24 py-275 text-gray-500 font-medium text-xs cursor-pointer border-2 rounded border-dashed border-blue-500 bg-primary-100':
      true,
    'text-primary-500 border-primary-500': isDragActive || isFileDialogActive,
    [className || '']: !!className,
  });

  return (pdfUrl && pdfUrl.trim().length === 0) || pdfUrl === undefined ? (
    <div {...(getRootProps({ className: classes }) as any)}>
      <div className="flex-col justify-center">
        {isDragActive ? (
          <span>{translations.attachments_label}</span>
        ) : (
          <div className="flex items-center justify-center">
            <img className="object-fit w-200" alt="" src={EMPTY_STATE_IMAGES.timesheet} />
          </div>
        )}
        <input
          type="file"
          className="hidden"
          formEncType="multipart/form-data"
          {...getInputProps()}
        />
        <p className="text-sm text-center font-medium mt-8"> Let’s start with a PDF doc </p>
        <button className="my-auto mx-auto py-12 flex rounded-sm font-medium bg-blue-500 text-white w-314 items-center justify-center">
          <div className="flex mx-auto">
            <AddIcon className="text-xs mt-6" />
            &nbsp;&nbsp;
            <span className="block">Upload a PDF</span>
          </div>
        </button>

        <p className="text-center text-xss mt-2">
          {' '}
          Drag and drop or click to add files you want to process
        </p>
      </div>
    </div>
  ) : !isLoading ? (
    <iframe src={pdfUrl} className="mx-20 w-3/5" frameBorder="0"></iframe>
  ) : (
    <LoaderXs className="mx-auto text-xss" />
  );
};
